export default __webpack_public_path__ + "static/media/udp2.3c536016.png";